var RSA = function (src) {
    var self = this;
    src = src || {};
    self.RSAId = src.RSAId || 0;
    self.Region = src.Region || '';
    self.OrgCode = src.OrgCode || '';
    self.RSA = src.RSA || '';
    self.Unit = src.Unit || '';

    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
}
angular.module('jcsfApp').value('RSA', RSA);